import { Translator } from 'Translator';
import { Filter } from 'model/Filters';
import FilterPopoverTrigger from 'modules/common/Popovers/FilterPopoverTrigger';
import LocalSpeaksPopover from 'modules/common/Popovers/LocalSpeaksPopover';
import usePopoverTrigger from 'modules/common/SubBars/ExperienceFilterSubNavbar/usePopoverTrigger';
import React from 'react';

interface LocalSpeaksTriggerProps {
  selectedLanguages: Filter;
}

function renderText(selectedLanguages) {
  if (!selectedLanguages || selectedLanguages.subOptions.length === 0) {
    return Translator.translate(
      'SearchPage.SearchResults.localSpeaks',
      {},
      true,
      'Local speaks',
    );
  }
  if (selectedLanguages.subOptions.length > 1) {
    return Translator.translate(
      'SearchPage.LanguageFilter.languages',
      { nr: selectedLanguages.subOptions.length },
      true,
      '{nr} languages',
    );
  }
  return Translator.translate(
    'SearchPage.LanguageFilter.language',
    { nr: 1 },
    true,
    '{nr} language',
  );
}

function getInitialLanguages(selectedLanguages) {
  return selectedLanguages
    ? selectedLanguages.subOptions.map((subOption) => subOption.id)
    : [];
}

function LocalSpeaksTrigger({ selectedLanguages }: LocalSpeaksTriggerProps) {
  const { show, togglePopover, closePopover } = usePopoverTrigger('languages');

  return (
    <FilterPopoverTrigger
      destination="/filter/languages/"
      text={renderText(selectedLanguages)}
      togglePopover={togglePopover}
      isActive={!!selectedLanguages}
      show={show}
    >
      <LocalSpeaksPopover
        initialSelectedLanguages={getInitialLanguages(selectedLanguages)}
        onClose={closePopover}
      />
    </FilterPopoverTrigger>
  );
}

export default LocalSpeaksTrigger;
